import "../../pages/new/new.scss"
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import "../datatable/datatable.scss"
import axiosInstance from "../../api/axios";
import { getBatches } from '../../services/studentService';

export const LectureLinks = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [editMode, setEditMode] = useState(false);
  const [viewMode, setViewMode] = useState(false);

  const [batches, setBatches] = useState([]);
  const [batchValue, setBatchValues] = useState();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    sessions: "",
    name: "",
    batch: "",
    reportType: "",
    presentationRecording: null,
    sessionRecording: null,
    rebuttalReportFileTemplate: null,
    reportFileTemplate: null,
    otherFileTemplate: null,

    // modes: file or link
    presentationRecordingMode: "file",
    sessionRecordingMode: "file",
    rebuttalReportFileTemplateMode: "file",
    reportFileTemplateMode: "file",
    otherFileTemplateMode: "file",
  });

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes('lecturelinks/edit-lecturelink')) setEditMode(true);
    else if (path.includes('view-lecturelink')) setViewMode(true);
  }, []);

  useEffect(() => {
    fetchBatches();
    if (id) {
      fetchLectureLink(id);
    } else {
      setLoading(false);
    }
  }, [id]);

  const fetchBatches = async () => {
    try {
      const batchdata = await getBatches();
      setBatches(batchdata.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchLectureLink = async (id) => {
  try {
    const res = await axiosInstance.get(`/getLectureLinkById?id=${id}`);
    const data = res.data.data ?? res.data;

    setFormData({
      id : id,
      sessions: data.sessions || "",
      name: data.name || "",
      batch: data.batch || "",
      reportType: data.report_type || "",
      presentationRecording: data.presentation_recording_link || "",
      sessionRecording: data.session_recording_link || "",
      rebuttalReportFileTemplate: data.rebuttal_report_template_link || "",
      reportFileTemplate: data.report_file_template_link || "",
      otherFileTemplate: data.other_file_template_link || "",
      presentationRecordingMode: data.presentation_recording_link ? "link" : "file",
      sessionRecordingMode: data.session_recording_link ? "link" : "file",
      rebuttalReportFileTemplateMode: data.rebuttal_report_template_link ? "link" : "file",
      reportFileTemplateMode: data.report_file_template_link ? "link" : "file",
      otherFileTemplateMode: data.other_file_template_link ? "link" : "file",
    });

    setBatchValues(data.batch || "");
  } catch (err) {
    console.error("Error fetching lecture link", err);
  } finally {
    setLoading(false);
  }
};



  const handleBatchChange = (event) => {
    const value = event.target.value;
    setBatchValues(value);
    setFormData({ ...formData, batch: value });
  };

  const validateForm = () => {
    const errors = {};
    if (!batchValue) {
      errors.batch = 'Batch is required';
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    setMessage("");

    try {
      const data = new FormData();

      const templateData = {
        id : id,
        sessions: formData.sessions,
        name: formData.name,
        batch: formData.batch,
        report_type: formData.reportType,
      };
      data.append("templateData", new Blob([JSON.stringify(templateData)], { type: "application/json" }));

      // append files or links dynamically
      ["presentationRecording", "sessionRecording", "rebuttalReportFileTemplate", "reportFileTemplate", "otherFileTemplate"].forEach((field) => {
      const value = formData[field];
      if (value instanceof File) {
        data.append(field, value);
      } else if (typeof value === "string" && value.trim() !== "") {
        data.append(`${field}Link`, value); // e.g. "presentationRecordingLink"
      }
    });


      if (editMode)
        await axiosInstance.put(`/updateTemplate?id=${id}`, data, { headers: { "Content-Type": "multipart/form-data" }, showToastOnResponse: true });
      else
        await axiosInstance.post("/addTemplate", data, { headers: { "Content-Type": "multipart/form-data" }, showToastOnResponse: true });

      setMessage(editMode ? "Lecture link updated successfully!" : "Lecture link shared successfully!");
      navigate('/lecturelinks');
    } catch (err) {
      console.error(err);
      setMessage("Failed to process. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const goBack = () => navigate('/lecturelinks');

  const renderUploadOrLink = (label, name, modeKey) => (
  <div>
  <label>{label}</label>

  <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
    <label>
      <input
        type="radio"
        name={`${name}Mode`}
        value="file"
        checked={formData[modeKey] === "file"}
        onChange={() => setFormData({ ...formData, [modeKey]: "file", [name]: null })}
        disabled={viewMode}
      />
      File
    </label>

    <label>
      <input
        type="radio"
        name={`${name}Mode`}
        value="link"
        checked={formData[modeKey] === "link"}
        onChange={() => setFormData({ ...formData, [modeKey]: "link", [name]: "" })}
        disabled={viewMode}
      />
      Link
    </label>
  </div>

  {formData[modeKey] === "file" ? (
    <input type="file" name={name} onChange={handleChange} disabled={viewMode} />
  ) : (
    <input
      type="text"
      name={name}
      placeholder="Paste Google Drive link"
      value={formData[name] || ""}
      onChange={handleChange}
      disabled={viewMode}
    />
  )}
</div>

);


  return (
    <div>
      <div className="top">
        <h1>{editMode ? 'Edit Lecture Link' : viewMode ? 'View Lecture Link' : 'Add Lecture Link'}</h1>
      </div>
      <div className="bottom">
        <div className="left"></div>
        <div className="right">
          <form onSubmit={handleSubmit}>
            <div className="formInput">
              <label>Session</label>
              <select name="sessions" value={formData.sessions} onChange={handleChange} disabled={viewMode} required>
                <option value="">-- Select Session --</option>
                <option value="Session 1">Session 1</option>
                <option value="Session 2">Session 2</option>
                <option value="Session 3">Session 3</option>
              </select>
            </div>

            <div className="formInput">
              <label>Report Type</label>
              <select name="reportType" value={formData.reportType} onChange={handleChange} disabled={viewMode} required>
                <option value="">-- Select Report Type --</option>
                <option value="ProjectProposal">Project Proposal</option>
                <option value="Phase1">Phase 1</option>
                <option value="Phase2">Phase 2</option>
                <option value="Phase3">Phase 3</option>
              </select>
            </div>

            <div className="formInput">
              <label>Name</label>
              <input type="text" name="name" placeholder="Enter name" value={formData.name} onChange={handleChange} disabled={viewMode} required />
            </div>

            <div className="formInput">
              <label>Select Batch</label>
              <select id="styled-dropdown" name="batch" value={batchValue} onChange={handleBatchChange} disabled={viewMode} required>
                <option value="">All Batches</option>
                {batches && batches.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
              {errors.batch && <div className="error-text">{errors.batch}</div>}
            </div>

            {!viewMode && (
              <>
                {renderUploadOrLink("Presentation Recording", "presentationRecording", "presentationRecordingMode")}
                {renderUploadOrLink("Session Recording", "sessionRecording", "sessionRecordingMode")}
                {renderUploadOrLink("Rebuttal Report Template", "rebuttalReportFileTemplate", "rebuttalReportFileTemplateMode")}
                {renderUploadOrLink("Report Template", "reportFileTemplate", "reportFileTemplateMode")}
                {renderUploadOrLink("Other File Template", "otherFileTemplate", "otherFileTemplateMode")}
              </>
            )}

            {viewMode && (
              <div className="formInput">
                <p><strong>Presentation:</strong> <a href={formData.presentationRecording} target="_blank" rel="noopener noreferrer">View File</a></p>
                <p><strong>Session Recording:</strong> <a href={formData.sessionRecording} target="_blank" rel="noopener noreferrer">View File</a></p>
                <p><strong>Rebuttal Template:</strong> <a href={formData.rebuttalReportFileTemplate} target="_blank" rel="noopener noreferrer">View File</a></p>
                <p><strong>Report Template:</strong> <a href={formData.reportFileTemplate} target="_blank" rel="noopener noreferrer">View File</a></p>
                <p><strong>Other File Template:</strong> <a href={formData.otherFileTemplate} target="_blank" rel="noopener noreferrer">View File</a></p>
              </div>
            )}

            <div className="buttons">
              {!viewMode && <button type="submit" style={{ cursor: loading ? "not-allowed" : "pointer" }}>{loading ? "Processing..." : (editMode ? "Update" : "Save")}</button>}
              <button onClick={goBack}>Back</button>
            </div>
          </form>
          {message && <p className="mt-4 text-center font-medium">{message}</p>}
        </div>
      </div>
    </div>
  );
};
